import { EVENTS } from '../utils/constants.js'

/**
 * Verifies that the locally-stored user still exists on the backend.
 * If the API returns a 404 or 401, the user is logged out automatically.
 * This prevents "ghost user" situations where localStorage contains stale data.
 */
async function verifyUserExists(context) {
  const { events, networkRepo } = context

  try {
    // GET /riders/profile?userId=xxx - will 404 if rider no longer exists
    const res = await networkRepo.sendRequest('get', null)

    // If the API explicitly says the user is not found or unauthorized, logout
    const statusCode = res?.statusCode ?? res?.error?.statusCode
    if (statusCode === 401 || statusCode === 404) {
      console.warn('[verifyUserExists] Rider not found on backend, logging out...')
      events.dispatch(EVENTS.LOGOUT_REQUESTED)
      return false
    }
  } catch (error) {
    const statusCode = error?.statusCode ?? error?.status
    if (statusCode === 401 || statusCode === 404) {
      console.warn('[verifyUserExists] Rider verification failed, logging out...')
      events.dispatch(EVENTS.LOGOUT_REQUESTED)
      return false
    }
    // For other errors (network issues, etc.) we silently continue – no logout
    console.warn('[verifyUserExists] Could not verify rider existence:', error?.message)
  }

  return true
}

export default verifyUserExists
